var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("validation-provider", {
    attrs: { rules: _vm.validation, name: _vm.errorName || _vm.label },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ errors, classes }) {
          return [
            _c(
              "div",
              { class: ["brb-select", classes] },
              [
                _c(
                  "multiselect",
                  {
                    class: [
                      "flex-grow-1 text-right",
                      {
                        "brb-multi-select": _vm.multiple,
                        "brb-single-select": !_vm.multiple,
                      },
                      _vm.inputClass,
                    ],
                    attrs: {
                      id: _vm.id,
                      "allow-empty": _vm.allowEmpty,
                      "deselect-label": _vm.deselectLabel,
                      disabled: _vm.disabled,
                      label: _vm.optionLabel,
                      multiple: _vm.multiple,
                      options: _vm.computedOptions,
                      searchable: _vm.searchable,
                      "select-label": _vm.selectLabel,
                      "selected-label": _vm.selectedLabel,
                      "show-labels": _vm.showLabels,
                      "track-by": _vm.trackBy,
                      placeholder: _vm.label || _vm.$t("shared.choose"),
                    },
                    on: {
                      select: function ($event) {
                        return _vm.$emit("select", $event)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "tag",
                          fn: function ({ option, remove }) {
                            return _c(
                              "div",
                              { staticClass: "barbanet-tag sm" },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(option[_vm.optionLabel])),
                                ]),
                                _c("font-awesome-icon", {
                                  staticClass:
                                    "text-danger mr-3 cursor-pointer",
                                  attrs: { icon: "times" },
                                  on: {
                                    mousedown: function ($event) {
                                      $event.preventDefault()
                                      return remove(option)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          },
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.model,
                      callback: function ($$v) {
                        _vm.model = $$v
                      },
                      expression: "model",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "text-muted text-center d-block py-1",
                        attrs: { slot: "noResult" },
                        slot: "noResult",
                      },
                      [_vm._v(" " + _vm._s(_vm.noResultText) + " ")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "text-muted text-center d-block py-1",
                        attrs: { slot: "noOptions" },
                        slot: "noOptions",
                      },
                      [_vm._v(" " + _vm._s(_vm.noOptionsText) + " ")]
                    ),
                    _c(
                      "span",
                      {
                        class: ["label", { selected: _vm.model }],
                        attrs: { slot: "placeholder" },
                        slot: "placeholder",
                      },
                      [
                        _c("span", { staticClass: "placeholder font-bold" }, [
                          _vm._v(_vm._s(_vm.label)),
                        ]),
                        _vm.required
                          ? _c("span", { staticClass: "text-danger" }, [
                              _vm._v(" * "),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "span",
                      { attrs: { slot: "singleLabel" }, slot: "singleLabel" },
                      [
                        _vm.model
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.model[_vm.optionLabel])),
                            ])
                          : _vm._e(),
                        _c(
                          "span",
                          {
                            class: [
                              "label font-bold",
                              _vm.model ? "selected" : "d-none",
                              _vm.labelClass,
                            ],
                          },
                          [
                            _vm._v(" " + _vm._s(_vm.label) + " "),
                            _vm.required
                              ? _c("span", { staticClass: "text-danger" }, [
                                  _vm._v("*"),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                errors && errors.length
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "d-block text-right text-danger small mt-2",
                      },
                      [_vm._v(" " + _vm._s(errors[0]) + " ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }